import { ServiceResult } from '../models';
import {
  CreateRecipeIngredientProductRequest,
  CreateRecipeIngredientProductsRequest,
  DeleteRecipeIngredientProductRequest,
  RecipeIngredientProduct,
  SequenceRecipeIngredientProductsRequest,
  UpdateRecipeIngredientProductRequest,
} from '../models/recipe-ingredient-product.models';
import ApiService from './api-service';

class RecipeIngredientProductService extends ApiService {
  private static classInstance: RecipeIngredientProductService;

  private constructor() {
    super('RecipeIngredientProduct');
  }

  public static getInstance(): RecipeIngredientProductService {
    if (!this.classInstance) {
      this.classInstance = new RecipeIngredientProductService();
    }
    return this.classInstance;
  }

  public getRecipeIngredientProductPrimary(
    recipeIngredientHeaderId: string,
    customerId: string
  ): ServiceResult<RecipeIngredientProduct> {
    return this.get(
      `${this.baseUrl}/GetRecipeIngredientProductPrimary?recipeIngredientHeaderId=${recipeIngredientHeaderId}&customerId=${customerId}`
    );
  }

  public getRecipeIngredientProduct(
    recipeIngredientProductId: string,
    customerId: string,
    deliveryDate?: string | Date
  ): ServiceResult<RecipeIngredientProduct> {
    let url = `${this.baseUrl}/GetRecipeIngredientProduct?recipeIngredientProductId=${recipeIngredientProductId}&customerId=${customerId}`;
    if (deliveryDate) url += `&deliveryDate=${deliveryDate}`;
    return this.get(url);
  }

  public getRecipeIngredientProducts(
    recipeIngredientHeaderId: string,
    customerId: string,
    deliveryDate?: string | Date
  ): ServiceResult<RecipeIngredientProduct[]> {
    let url = `${this.baseUrl}/GetRecipeIngredientProducts?recipeIngredientHeaderId=${recipeIngredientHeaderId}&customerId=${customerId}`;
    if (deliveryDate) url += `&deliveryDate=${deliveryDate}`;
    return this.get(url);
  }

  public createRecipeIngredientProduct(
    request: CreateRecipeIngredientProductRequest
  ): ServiceResult<RecipeIngredientProduct> {
    return this.post(`${this.baseUrl}/CreateRecipeIngredientProduct`, request);
  }

  public createRecipeIngredientProducts(
    request: CreateRecipeIngredientProductsRequest
  ): ServiceResult<RecipeIngredientProduct[]> {
    return this.post(`${this.baseUrl}/CreateRecipeIngredientProducts`, request);
  }

  public updateRecipeIngredientProduct(
    request: UpdateRecipeIngredientProductRequest
  ): ServiceResult<RecipeIngredientProduct> {
    return this.post(`${this.baseUrl}/UpdateRecipeIngredientProduct`, request);
  }

  public deleteRecipeIngredientProduct(request: DeleteRecipeIngredientProductRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/DeleteRecipeIngredientProduct`, request);
  }

  public sequenceRecipeIngredientProducts(request: SequenceRecipeIngredientProductsRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/SequenceRecipeIngredientProducts`, request);
  }
}

export default RecipeIngredientProductService;
